export const getCountryNameByCode = (countryCode, countryList) => {
    const { countries } = countryList;
    return countries?.[countryCode]?.countryName ?? countryCode;
};

const getStateNameByCodeFromList = (stateCode, stateList) => {
    return stateList?.filter(stateObj => stateObj.code === stateCode)[0]?.name;
};

export const getStateNameByCode = (stateCode, countryCode, { countries }) => {
    return getStateNameByCodeFromList(stateCode, countries?.[countryCode]?.provinces) ?? stateCode;
};
